import common from '@/routes/resvMng/common'
import spfc from '@/routes/resvMng/spfc'
import lect from '@/routes/resvMng/lect'
import play from '@/routes/resvMng/play'
import expr from '@/routes/resvMng/expr'
import camp from '@/routes/resvMng/camp'

const routes = [
    ...common, // 공통
    ...spfc, // 체육시설
    ...lect, // 교육/강좌
    ...play, // 공연/전시
    ...expr,  // 견학/체험
    ...camp, // 캠핑
]

export default routes